//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[0,"EnumPostCrossStyle",1,0],[0,"EnumRailCrossStyle",1,0],[0,"EnumSpacingType",1,0],[0,"IntegerCount",1,0],[0,"IsSketchInternal",1,0],[1,"LinearDimBottomElevation",0,"Expression",0],[1,"LinearDimPitchBy",0,"Expression",0],[1,"LinearDimPostCrossDia",0,"Expression",0],[1,"LinearDimPostCrossLength",0,"Expression",0],[1,"LinearDimPostCrossTickness",0,"Expression",0],[1,"LinearDimPostCrossWidth",0,"Expression",0],[1,"LinearDimPostHeight",0,"Expression",0],[1,"LinearDimPostSpacing",0,"Expression",0],[1,"LinearDimRailCrossDia",0,"Expression",0],[1,"LinearDimRailCrossLength",0,"Expression",0],[1,"LinearDimRailCrossWidth",0,"Expression",0],[1,"OnPathDimSpanBy",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"PostOffset",1,0],[1,"SelectionCurves",0,"Section",0],[1,"SelectionPostCrossSection",0,"Section",0]],[],[]];
SPLM.LineDesigner.RailingFeatureBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.RailingFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LineDesigner.RailingFeatureBuilder.PostOffsetType = Object.freeze({
    "PostOnCurve" : "PostOnCurve", "PostLeftOfCurve" : "PostLeftOfCurve", "PostRightOfCurve" : "PostRightOfCurve"});

SPLM.LineDesigner.RailingFeatureBuilder.SelPostcrossStyle = Object.freeze({
    "IBeam" : "IBeam", "Rectangle" : "Rectangle", "Circle" : "Circle", "UserDefine" : "UserDefine"});

SPLM.LineDesigner.RailingFeatureBuilder.RailCrossStyle = Object.freeze({
    "Rectangle" : "Rectangle", "Circle" : "Circle"});

SPLM.LineDesigner.RailingFeatureBuilder.SpaceType = Object.freeze({
    "CountandSpan" : "CountandSpan", "PitchandSpan" : "PitchandSpan", "CountandPitch" : "CountandPitch"});

export default SPLM;